import Hero from './components/Hero';
import Countdown from './components/Countdown';
import About from './components/About';
import Topics from './components/Topics';
import Timeline from './components/Timeline';
import Venue from './components/Venue';
import Speakers from './components/Speakers';
import ProgrammeCommittee from './components/ProgrammeCommittee';

function Home() {

  return (
    <main className="">
        <Hero />
        {/* <Countdown /> */}
        <About />
        <Topics />
        <Speakers />
        <Timeline />
        <Venue />
        <ProgrammeCommittee />
    </main>
  );
}

export default Home;